import React from 'react';

import styles from './SimpleAlert.module.css';

export type messageType = 'success' | 'error';

export interface SimpleMessageProps {
  children?: React.ReactNode
  type: messageType
}


const SimpleAlert = ({children, type}: SimpleMessageProps) => {
  return <span className={styles[type]}>{children}</span>
};

SimpleAlert.defaultProps = {
  type: 'success'
};

export default SimpleAlert